import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PageTitleService } from '../../services/page-title/page-title.service';
import { Chat } from '../chat';

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss'],
    standalone: false,
})
export class ChatComponent implements OnInit {
    currentChat: Chat;

    constructor(
        private pageTitleService: PageTitleService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.pageTitleService.setTitle('Meldingen');
    }

    openChat(chat: Chat) {
        this.currentChat = chat;
        this.pageTitleService.setTitle(chat ? 'Melding' : 'Meldingen', chat?.name);
        this.cdr.detectChanges();
    }
}
